import Cookies from 'js-cookie'
import { checkToken as request } from '@/api/user'

const TokenKey = 'Admin-Token'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

export const checkToken = async () => {
  try {
    const res = await request();
    return res.code === '200'
  } catch (error) {
    return false
  }
}
